import React, { useRef, useEffect } from 'react';

export const ShaderLines = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let time = 0;

    const resize = () => {
      // Get the parent element's dimensions
      const parent = canvas.parentElement;
      if (parent) {
        canvas.width = parent.offsetWidth;
        canvas.height = parent.offsetHeight;
      } else {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    };
    
    window.addEventListener('resize', resize);
    resize();

    const draw = () => {
      time += 0.005;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      const lines = 30; // Number of horizontal lines
      
      for (let i = 0; i < lines; i++) {
        ctx.beginPath();
        const yOffset = (canvas.height / lines) * i;
        
        for (let x = 0; x < canvas.width; x += 30) {
          // Create smooth wave patterns combining multiple sine waves
          const wave1 = Math.sin(x * 0.002 + time + i * 0.1) * 30;
          const wave2 = Math.cos(x * 0.005 - time * 1.5) * 15;
          const y = yOffset + wave1 + wave2;
          
          if (x === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        
        // Create glowing gradient effect for each line
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        
        // Dynamic opacity based on time and line index
        const baseOpacity = (Math.sin(time * 2 + i * 0.5) * 0.5 + 0.5) * 0.2 + 0.05;
        
        gradient.addColorStop(0, 'rgba(6, 182, 212, 0)');
        gradient.addColorStop(0.2, `rgba(6, 182, 212, ${baseOpacity})`);
        gradient.addColorStop(0.5, `rgba(6, 182, 212, ${baseOpacity * 1.5})`);
        gradient.addColorStop(0.8, `rgba(6, 182, 212, ${baseOpacity})`);
        gradient.addColorStop(1, 'rgba(6, 182, 212, 0)');
        
        ctx.strokeStyle = gradient;
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }

      animationFrameId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{ mixBlendMode: 'screen' }}
    />
  );
};